import { ApolloQueryResult } from "@apollo/client";
import { Layout } from "components/layout";
import { AboutSection } from "components/shop/subscription/AboutSection";
import { GiftSubscriptionSection } from "components/shop/subscription/GiftSubscriptionSection";
import { HowToSection } from "components/shop/subscription/HowToSection";
import { SubscribeSection } from "components/shop/subscription/SubscribeSection";
import {
  GetSubscriptionDocument,
  GetSubscriptionQueryResult,
  GetSubscriptionQueryVariables,
  useGetSubscriptionQuery,
} from "lib/graphql-generated";
import { addApolloState, initializeApollo } from "lib/hooks/apollo-client";
import { useBasket } from "lib/hooks/basket/use-basket";
import { useIsInBasket } from "lib/hooks/basket/use-is-in-basket";
import { parseParam } from "lib/utils";
import { GetServerSideProps } from "next";

interface Props {
  slug: string;
}

export type SubscriptionPageSub =
  GetSubscriptionQueryResult["data"]["subscriptions"][0];

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return { notFound: true };

  const client = initializeApollo();
  const slug = parseParam(ctx.params.slug);

  const { data }: ApolloQueryResult<GetSubscriptionQueryResult["data"]> =
    await client.query({
      query: GetSubscriptionDocument,
      variables: {
        slug: slug,
      } as GetSubscriptionQueryVariables,
    });

  if (data.subscriptions.length > 0) {
    return addApolloState(client, {
      props: { slug: slug } as Props,
    });
  } else {
    return {
      notFound: true,
    };
  }
};

export const Subscription = ({ slug }: Props) => {
  const { data, loading, error } = useGetSubscriptionQuery({
    variables: {
      slug,
    },
  });

  const [basket, modifyBasket] = useBasket();
  // const payload = {
  //   type: "add",
  //   payload: {
  //     type: "product",
  //     id: subscription.id,
  //     data: {
  //       price: subscription.price,
  //       discount: 0,
  //       quantity: 1,
  //       subscription: {
  //         id: subscription.id,
  //         image: subscription.image,
  //         title: subscription.title,
  //       },
  //     },
  //   },
  // }

  const isInBasket = useIsInBasket("");
  const subscription = data.subscriptions.find((sub) => sub.slug === slug);

  return (
    <Layout pageName={subscription.title}>
      <article className=' max-w-screen-2xl [ grid grid-cols-1 gap-y-6 gap-x-4 py-6 px-4 ] [ md:grid-cols-2 ] [ lg:grid-cols-6 ] w-full justify-items-center mx-auto 2xl:px-0'>
        <img
          alt={`Cover for: ${subscription.title}`}
          className=' w-full [ order-1 ] [ lg:col-span-2 ] '
          src={subscription.image}
        />

        <section className='flex flex-col w-full order-4 col-span-full [  ] [ lg:order-2 lg:col-span-2 lg:col-start-1 ] '>
          <HowToSection data={data.unstructured_data_by_pk.data} />
        </section>

        <section className='flex flex-col order-2 w-full [ lg:col-span-4 lg:row-start-1 lg:col-start-3 ]'>
          <AboutSection subscription={subscription} />
        </section>

        <section className='flex flex-col space-y-4 py-2 w-full [ order-5 ] [ md:col-span-full ] [ lg:col-span-2 lg:col-start-3 ] '>
          <SubscribeSection subscription={subscription} />
        </section>

        <section className='flex flex-col space-y-4 py-2 w-full [ order-6 ] [ md:col-span-full ] [ lg:col-span-2 ] '>
          <GiftSubscriptionSection subscription={subscription} />
        </section>
      </article>
    </Layout>
  );
};
export default Subscription;
